import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { ChoiceOption } from '~/containers/ChoiceOption/ChoiceOption';
import { InitializeEvent } from '~/containers/InitializeEvent/InitializeEvent';
import { SponsorLeadCapture } from '~/containers/SponsorLeadCapture/SponsorLeadCapture';
import TicketScanner from '~/containers/TicketScanner/TicketScanner';
import { VoucherScanner } from '~/containers/VoucherScanner/VoucherScanner';
import { useCheckEventLoaded } from '~/hooks/useCheckEventLoaded';

export const AppRouter = () => {

	const status = useCheckEventLoaded();
	const location = useLocation();
	// The sponsor-scan route owns its own bootstrap (token exchange via the link's `?t=` param).
	// Skip the ticket-scanner's event-cache gate so visiting the deep-link with a fresh
	// browser still resolves to the booth lead-capture flow instead of bouncing to `/`.
	const isSponsorScanRoute = /^\/event\/[^/]+\/sponsor-scan\b/.test(location.pathname);

	if (isSponsorScanRoute) {
		return (
			<Routes>
				<Route
					path="event/:eventAccessCode/sponsor-scan/:sponsorId"
					element={<SponsorLeadCapture />}
				/>
				<Route path="*" element={<Navigate to="/" replace={true} />} />
			</Routes>
		);
	}

	return (
		<>
			<Routes>
				{
					(status === 'loaded')
					? (
						<>
							<Route path="event/:id/vouchers" element={<VoucherScanner />} />
							<Route path="event/:id/tickets" element={<TicketScanner />} />
							<Route path="event/:id" element={<ChoiceOption />} />
							{/* <Route path="event" element={<InitializeEvent /> } /> */}
							<Route path="/" element={<InitializeEvent />} />
							<Route path="*" element={<Navigate to="/" replace={true} />} />
						</>
						)
					: (
						<>
							<Route path="event/:id" element={<ChoiceOption />} />
							<Route path="/" element={<InitializeEvent />} />
							<Route path="*" element={<Navigate to="/" replace={true} />} />
						</>
					)
				}
			</Routes>
		</>
	)
}
